import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";

import { RestApiContextProvider } from "@/context/api";
import { AuthContextProvider } from "@/context/auth";

interface AppProvidersProps {
  children: React.ReactNode;
}
export const AppProviders = (props: AppProvidersProps) => {
  const { children } = props;
  const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <RestApiContextProvider>
        <AuthContextProvider>{children}</AuthContextProvider>
      </RestApiContextProvider>
    </QueryClientProvider>
  );
};
